import React, {useEffect, useRef, useState} from 'react'
import {Empty, Input, Modal, Pages, Seperator, Thumbnail} from "../../../../../retro";
import {useParams} from "react-router-dom";
import {get, post} from "../../../../Network/Axios";
import useFunctionallityHook from "../../../../Hooks/useFunctionallityHook";

export default function ApiUser() {
    const {id} = useParams();
    const EMAIL = useRef();
    const [modal,setModal] = useState(false)
    const [email,setEmail] = useState([])
    const load = id => {
        get(`/clients/theme/${id}/email/blacklist`,(e,r)=>{
            if(r){
                setEmail(r.blacklist)
            }
        })
    }
    useEffect(()=>{
        load(id)
    },[id])
  
	return (
		<div>
            <Seperator margin={5}/>
            {
                modal && <Modal onClose={()=>{setModal(false)}} title="Add Email" description="Enter details below to blacklist email">
                    {
                        modal && <div>
                                <Input ref={EMAIL} type="email" label="Email Address" placeholder="Enter email address"/>
                            <p onClick={()=>{
                              let email = EMAIL.current.value;
                                post(`/clients/theme/${id}/email/blacklist`,{email},(e,r)=>{
                                    if(r){
                                        load(id)
                                        setModal(false)
                                    }
                                })
                            }} className="btn btn-black  mt4" style={{
                                maxWidth:100
                            }}>
                                Add
                            </p>
                        </div>
                    }
                </Modal>
            }
            <Pages.Title title="Blacklisted Email" description="Manage all blacklisted email for this client."/>
            <div className="border pd4 mt4 rounded-sm">
                <p className="fw-bold">
                    All Email
                </p>
                {
                    email.map(item=>{
                        return (
                            <div className="border flex center-vertically border-sm pd2 rounded-sm mt2">
                                <Thumbnail size="L" letter="A"/>
                                <div className="ml2">
                                    <p className="fw-bold">
                                        {item}
                                    </p>
                                   
                                    <p onClick={()=>{
                                        post(`/clients/theme/${id}/email/blacklist/remove`,{email:item},(e,r)=>{
                                            if(r){
                                                load(id)
                                            }
                                        })
                                    }} className="btn btn-link">
                                        Delete
                                    </p>
                                </div>
                            </div>
                        )
                    })
                }
                {email.length===0&&<Empty/>}
                <p onClick={()=>{
                    setModal(true)
                }} className="btn btn-black  mt4" style={{
                    maxWidth:200
                }}>
                    + Add Email
                </p>
            </div>
        </div>
	)
}
